const PointerIcon = () => (
  <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0.673237V11.4334C0 11.7875 0.309375 12.0718 0.6875 12.0718C0.884375 12.0718 1.075 11.9935 1.20625 11.8542L3.7875 9.11192L5.60313 12.4868C5.85 12.9453 6.45 13.131 6.94375 12.9018C7.4375 12.6725 7.6375 12.1154 7.39062 11.6569L5.61875 8.35743H9.30937C9.69063 8.35743 10 8.07014 10 7.71611C10 7.53329 9.91563 7.35918 9.76875 7.2373L1.20625 0.171211C1.07187 0.0609396 0.903125 0 0.725 0C0.325 0 0 0.301796 0 0.673237Z"
      fill="black"
    />
  </svg>
);

export default PointerIcon;
